import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    paddingBottom: 30,
    '& p': {
      fontSize: 20,
    },
  },
  closeIcon: {
    cursor: 'pointer',
  },
  close: {
    marginTop: '1rem',
    textAlign: 'right',
  },
  contentRoot: {
    padding: 0,
    paddingLeft: 50,
    paddingRight: 50,
  },
  root: {
    '& .MuiDialogContent-root:first-child': {
      paddingTop: 50,
    },
    '& .MuiDialogActions-root': {
      paddingBottom: 50,
      paddingRight: 60,
    },

    '& .MuiDialog-paperWidthSm': {
      maxWidth: 668,
    },
    '& .MuiPaper-root': {
      borderRadius: 20,
    },
    padding: 0,
  },
  paper: { minWidth: 1030, height: 'auto' },
  sectionTitle: {
    padding: '1rem 0',
  },
  closeButton: {
    color: theme.palette.primary.main,
    fontSize: 18,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'transparent',
      fontWeight: 'bold',
    },
  },
}));

export default useStyles;
